import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import { Component } from 'react';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { toast } from 'react-toastify';

let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];

class StudentResource extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //VARIABLE TO GET E-RESOURCE  DATA LIST
            resourceListLoading: false,
            resourceDetailsList: {},
            totalResourcesItems: 0,
            sortedIdArray: [],

            linkedInstituteArray: {},
            linkedIidArray: [],

            // filter
            resourceSearchTitle: '',
            resourceSearchAuthor: '',
            filterInstituteIID: config.institute_id,
            resourceSearchAccessionNumber: '',
            isFilterLoading: false,

            GetStreamList: {},
            loadingStreamData: false,

            GetLocationList: {},
            loadingLocationData: false,

            //advance filter modal
            advanceFilterModal: false,
            departmentAdvanceFilterValue: [],
            locationAdvanceFilterValue: [],
            typeAdvanceFilterValue: [],
            resourceSearchAccessionSeries: [],

            loadingFilterAccessionSeries: false,
            filterAccessionSeriesData: [],

            loadingFilterDepartment: false,
            filterDepartmentData: [],

            loadingFilterLocation: false,
            filterLocationData: [],
        }
    }

    componentDidMount() {
        this.GetAssignedInstituteList();
        this.GetLibraryResourceDetailsList();

        // filter API call
        this.apiFilterGetAccessionSeries(); // accession series
        this.apiFilterGetInstituteStreamList();  // department
        this.apiFilterLibraryLocationList();  // location list
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                // this.GetLibraryResourceDetailsList();
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    GetLibraryResourceDetailsList = async () => {
        this.setState({ resourceListLoading: true })

        let requestData = {
            "iid": this.state.filterInstituteIID,
            // "iidArray": this.state.linkedIidArray,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "type": "All"
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceDetailsList',
            requestData,
            '/api/library/learner.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceDetailsList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            resourceDetailsList: apiResult.data,
                            totalResourcesItems: apiResult.resource_count,
                            sortedIdArray: apiResult.sortedIdArray,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceDetailsList: {},
                            totalResourcesItems: 0,
                            sortedIdArray: [],
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceDetailsList: {},
                        resourceListLoading: false,
                        sortedIdArray: []
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    // filtered list
    GetFilteredLibraryResourceList = async () => {
        this.setState({
            resourceListLoading: true
        });

        let accessionSeriesIdArray = [];
        let departmentIdArray = [];
        let locationIdArray = [];
        let typeNameArray = [];

        this.state.resourceSearchAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })

        this.state.departmentAdvanceFilterValue?.map((item) => {
            departmentIdArray.push(item.value)
        })

        this.state.locationAdvanceFilterValue?.map((item) => {
            locationIdArray.push(item.value)
        })

        this.state.typeAdvanceFilterValue?.map((item) => {
            typeNameArray.push(item.value)
        })

        let searchTitleValue = this.state.resourceSearchTitle ? btoa(encodeURIComponent(this.state.resourceSearchTitle.trim())) : "";
        let searchAuthorValue = this.state.resourceSearchAuthor ? btoa(encodeURIComponent(this.state.resourceSearchAuthor.trim())) : "";
        let searchAccessionNumberValue = this.state.resourceSearchAccessionNumber ? this.state.resourceSearchAccessionNumber.trim() : "";
        let searchAccessionSeriesValue = accessionSeriesIdArray;
        let searchDepartmentValue = departmentIdArray;
        let searchLocationValue = locationIdArray;
        let searchTypeValue = typeNameArray;

        let filterParameter = {
            "instituteId": this.state.filterInstituteIID,
            "searchTitle": searchTitleValue,
            "searchAuthor": searchAuthorValue,
            "searchAccessionNumber": searchAccessionNumberValue,
            "filteredIID": this.state.filterInstituteIID,
            "searchresourcecategory": [],
            "searchinvoice": [],
            "searchseries": searchAccessionSeriesValue,
            "streams": searchDepartmentValue,
            "searchlocation": searchLocationValue,
            "searchType": searchTypeValue,
        }

        let requestData = {
            iid: config.institute_id,
            pageIndex: this.state.pageIndex,
            limitPerPage: this.state.limit,
            filterParameter: filterParameter,
            iidArray: [this.state.filterInstituteIID]
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            "GetFilteredLibraryResourceList",
            requestData,
            "/api/library/learner.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetFilteredLibraryResourceList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            resourceDetailsList: apiResult.data,
                            totalResourcesItems: apiResult.resource_count,
                            sortedIdArray: apiResult.sortedIdArray,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceDetailsList: {},
                            totalResourcesItems: 0,
                            sortedIdArray: [],
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceDetailsList: {},
                        resourceListLoading: false,
                        sortedIdArray: []
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    };

    //FILTER API CALL METHOD TO GET ACCESSION SERIES
    apiFilterGetAccessionSeries = async () => {
        this.setState({ loadingFilterAccessionSeries: true });

        let accessionSeriesValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            "iid": config.institute_id,
            "iidArray": accessionSeriesValue
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                    iid: seriesData.iid,
                    uniqueId: seriesId
                }));

                this.setState({
                    filterAccessionSeriesData: formattedMembers,
                    loadingFilterAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingFilterAccessionSeries: false
                });
            }
        }
    }

    //FILTER API CALL TO GET get Institute Stream List 
    apiFilterGetInstituteStreamList = async () => {
        this.setState({
            loadingFilterDepartment: true,
        })

        let multipleInstistuteStreamValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            "iidArray": multipleInstistuteStreamValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetMultipleInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    filterDepartmentData: apiResult.data,
                    loadingFilterDepartment: false,
                })
            } else {
                this.setState({
                    loadingFilterDepartment: false,
                })
            }
        }
    }

    //FILTER API CALL TO GET get location List 
    apiFilterLibraryLocationList = async () => {
        this.setState({
            loadingFilterLocation: true,
        })

        let locationValue = Array.isArray(this.state.filterInstituteIID)
            ? this.state.filterInstituteIID
            : [this.state.filterInstituteIID];

        let requestData = {
            iid: config.institute_id,
            iidArray: locationValue
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryLocationList',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryLocationList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const sublocations = [];

                    // If there are sublocations, iterate through them
                    if (seriesData.subLocationCount > 0) {
                        Object.entries(seriesData.sublocation).forEach(([sublocationId, sublocationData]) => {
                            sublocations.push({
                                sublocationId: sublocationId,
                                sublocationName: sublocationData.name
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        sublocations: sublocations // Add sublocation data (if any)
                    };
                });

                this.setState({
                    filterLocationData: formattedData,
                    loadingFilterLocation: false,
                })
            } else {
                this.setState({
                    loadingFilterLocation: false,
                })
            }
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        let filterIidValue = "";
        if (this.state.filterInstituteIID.length > 1) {
            filterIidValue = ""
        } else {
            filterIidValue = this.state.filterInstituteIID[0]
        }

        if (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.filterInstituteIID !== (config.institute_id) || this.state.resourceSearchAccessionSeries?.length > 0 || this.state.resourceSearchAccessionNumber !== "" || this.state.departmentAdvanceFilterValue?.length > 0 || this.state.locationAdvanceFilterValue?.length > 0 || this.state.typeAdvanceFilterValue?.length > 0) {
            this.setState({
                pageIndex: pageNumber, resourceSearchTitle: this.state.resourceSearchTitle, resourceSearchAuthor: this.state.resourceSearchAuthor, filterInstituteIID: this.state.filterInstituteIID?.length > 0 ? filterIidValue : this.state.filterInstituteIID,
                resourceSearchAccessionSeries: this.state.resourceSearchAccessionSeries, resourceSearchAccessionNumber: this.state.resourceSearchAccessionNumber,
                departmentAdvanceFilterValue: this.state.departmentAdvanceFilterValue, locationAdvanceFilterValue: this.state.locationAdvanceFilterValue, typeAdvanceFilterValue: this.state.typeAdvanceFilterValue
            }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ selectedRows: [], pageIndex: pageNumber }, () => {
                this.GetLibraryResourceDetailsList();
            });
        }
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        let filterIidValue = "";
        if (this.state.filterInstituteIID.length > 1) {
            filterIidValue = ""
        } else {
            filterIidValue = this.state.filterInstituteIID[0]
        }

        if (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.filterInstituteIID !== (config.institute_id) || this.state.resourceSearchAccessionSeries?.length > 0 || this.state.resourceSearchAccessionNumber !== "" || this.state.departmentAdvanceFilterValue?.length > 0 || this.state.locationAdvanceFilterValue?.length > 0 || this.state.typeAdvanceFilterValue?.length > 0) {
            this.setState({
                pageIndex: 1, limit: event.target.value, resourceSearchTitle: this.state.resourceSearchTitle, resourceSearchAuthor: this.state.resourceSearchAuthor, filterInstituteIID: this.state.filterInstituteIID?.length > 0 ? filterIidValue : this.state.filterInstituteIID,
                resourceSearchAccessionSeries: this.state.resourceSearchAccessionSeries, resourceSearchAccessionNumber: this.state.resourceSearchAccessionNumber,
                departmentAdvanceFilterValue: this.state.departmentAdvanceFilterValue, locationAdvanceFilterValue: this.state.locationAdvanceFilterValue, typeAdvanceFilterValue: this.state.typeAdvanceFilterValue
            }, () => {
                this.GetFilteredLibraryResourceList();
            });
        } else {
            this.setState({ pageIndex: 1, limit: event.target.value }, () => {
                this.GetLibraryResourceDetailsList();
            });
        }
    }

    // resource filter title on change
    handleResourceTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchTitle: event.target.value });
    };
    handleResourceTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // resource filter author on change
    handleResourceAuthorChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchAuthor: event.target.value });
    };
    handleResourceAuthorKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // resource filter accession no on change
    handleResourceAccessionNoChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", resourceSearchAccessionNumber: event.target.value });
    };
    handleResourceAccessionNoKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetFilteredLibraryResourceList();
        }
    };

    // Advance Filter Model - Method to open modal
    advanceFilterModal = () => {
        this.setState({
            advanceFilterModal: true,
        })
    }

    closeAdvanceFilterModal = () => {
        this.setState({
            advanceFilterModal: false,
            eResourceTitle: "",
            eResourceAuthor: "",
            eResourceCateogry: "",
            eResourceSearchKeyword: "",
            eResourceType: "",
            eResourceFromDate: "",
            eResourceToDate: "",
            eResourceAcademicYear: "",
            eResourceSortByTitle: "ASC",
        })
    }

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div className={this.state.advanceFilterModal ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                            <h6 className="modal-title">
                                {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px' }} /> */}
                                <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                                Advanced Filter
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeAdvanceFilterModal()} style={{ cursor: "pointer" }} />
                        </div>

                        {/* Modal Content */}
                        <div className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }}>
                            {/* Form Group: Accession Series &  Department */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Accession Series
                                    </label>
                                    <Select
                                        isMulti
                                        name="SeriesAdvFilter"
                                        options={Object.values(this.state.filterAccessionSeriesData)}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                resourceSearchAccessionSeries: event || [], // Handle empty selection
                                                searchMultipleAccessionNumber: [], searchAccessionNumberFrom: '', searchAccessionNumberTo: ''
                                            })
                                        }}
                                        value={this.state.resourceSearchAccessionSeries}
                                        placeholder="Select Accession Series"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceDepartmentFilter">
                                        Department
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceDepartmentFilter"
                                        options={Object.entries(this.state.filterDepartmentData).map(([key, item]) => ({
                                            value: key,  // set the key (like "267") as the value
                                            label: (item?.instituteShortCode) ? `${item.stream_name} | ${item.instituteShortCode}` : `${item.stream_name}`
                                        }))}
                                        value={this.state.departmentAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                departmentAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Department"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: type and Location */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceLocationFilter">
                                        Location
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceLocationFilter"
                                        options={Object.values(this.state.filterLocationData)?.flatMap((data) => {
                                            // Start with the parent location itself
                                            const locationOption = {
                                                value: data.value,
                                                label: data.name,
                                                isDisabled: data.sublocations && data.sublocations.length > 0, // Disable the parent if it has sublocations
                                            };

                                            // If the location has sublocations, add them as well
                                            const subLocationOptions = data.sublocations?.map((sublocation) => ({
                                                value: sublocation.sublocationId,
                                                label: `${data.name} => ${sublocation.sublocationName}`, // Parent location followed by sublocation name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the location option followed by the sublocation options
                                            return [locationOption, ...subLocationOptions];
                                        })}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                locationAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        value={this.state.locationAdvanceFilterValue}
                                        placeholder="Select Location"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="resourceTypeFilter">
                                        Resource Type
                                    </label>
                                    <Select
                                        isMulti
                                        name="resourceTypeFilter"
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.typeAdvanceFilterValue}
                                        onChange={(event) => {
                                            this.setState({
                                                pageIndex: 1, limit: "10",
                                                typeAdvanceFilterValue: event || [], // Handle empty selection
                                            })
                                        }}
                                        placeholder="Select Resource Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn custom-btn"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                // borderColor: '#0465AC !important'
                                onClick={() => {
                                    this.closeAdvanceFilterModal();
                                    this.setState({
                                        resourceSearchAccessionSeries: [],
                                        resourceSearchAccessionNumber: '',
                                        filterInstituteIID: config.institute_id,
                                        resourceSearchTitle: '',
                                        resourceSearchAuthor: '',
                                        limit: 10, pageIndex: 1,
                                        departmentAdvanceFilterValue: [],
                                        locationAdvanceFilterValue: [],
                                        typeAdvanceFilterValue: []
                                    }, () => {
                                        this.GetLibraryResourceDetailsList();
                                        this.apiFilterGetAccessionSeries(); // accession series
                                        this.apiFilterGetInstituteStreamList();  // department
                                        this.apiFilterLibraryLocationList();  // location list
                                    })
                                }}
                            >
                                Clear
                            </button>
                            <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                                this.GetFilteredLibraryResourceList();
                                this.setState({ advanceFilterModal: false })
                            }}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // CLEAR ALL FILTER
    handleClearAllResourceFilter = () => {
        this.setState({
            resourceSearchAccessionSeries: [], resourceSearchAccessionNumber: '', filterInstituteIID: config.institute_id, resourceSearchTitle: '', resourceSearchAuthor: '', limit: 10, pageIndex: 1, departmentAdvanceFilterValue: [], locationAdvanceFilterValue: [],
            typeAdvanceFilterValue: []
        }, () => {
            this.GetLibraryResourceDetailsList();
            this.apiFilterGetAccessionSeries(); // accession series
            this.apiFilterGetInstituteStreamList();  // department
            this.apiFilterLibraryLocationList();  // location list
        })
    };

    render() {
        return (
            <>
                <RoutingMenu activeScreen="userResource" />

                <div className="libraryComponents-container pr-3">
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4>Library Resources</h4>
                        </div>
                    </div>

                    {/* Filter resource */}
                    <div>
                        <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                            <div style={{ width: '100%' }}>
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        {/* Based On Institute */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Institute</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <select
                                                    className="form-control formControlContentTask"
                                                    style={{
                                                        width: 'auto',
                                                        height: '42px',
                                                        fontSize: "13px",
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        fontFamily: "'Poppins', sans-serif",
                                                        color: '#808080',
                                                        borderRadius: '7px'
                                                    }}
                                                    id="resourceInstituteFilterID"
                                                    onChange={(e) => {
                                                        const selectedIID = e.target.value;
                                                        if (selectedIID) {
                                                            const numericIID = Number(selectedIID);

                                                            this.setState(
                                                                {
                                                                    filterInstituteIID: numericIID,
                                                                    pageIndex: 1,
                                                                    limit: 10,
                                                                    resourceSearchAccessionSeries: [],
                                                                },
                                                                () => {
                                                                    this.GetFilteredLibraryResourceList();
                                                                    this.apiFilterGetInstituteStreamList();  // department
                                                                    this.apiFilterGetAccessionSeries(); // accession series
                                                                    this.apiFilterLibraryLocationList();  // location list
                                                                }
                                                            );
                                                        }
                                                        else {

                                                            this.setState(
                                                                {
                                                                    filterInstituteIID: this.state.linkedIidArray,
                                                                    pageIndex: 1,
                                                                    limit: 10,
                                                                    resourceSearchAccessionSeries: [],
                                                                },
                                                                () => {
                                                                    this.GetFilteredLibraryResourceList();
                                                                    this.apiFilterGetInstituteStreamList();  // department
                                                                    this.apiFilterGetAccessionSeries(); // accession series
                                                                    this.apiFilterLibraryLocationList();  // location list
                                                                }
                                                            );
                                                        }
                                                    }}
                                                    value={this.state.filterInstituteIID} // handle array safely
                                                >
                                                    <option value="">Select Institute</option>

                                                    {Object.values(this.state.linkedInstituteArray || {}).map((member) => (
                                                        <option key={member.iid} value={member.iid}>
                                                            {member.institute_name}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>

                                        {/* Based On Title */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Resource Title</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceTitleFilterID"
                                                    placeholder="Search by Title "
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchTitle} // Bind value to state
                                                    onChange={this.handleResourceTitleChange} // Handle input changes
                                                    onKeyPress={this.handleResourceTitleKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based On Resource Author */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Author</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceAuthorFilterID"
                                                    placeholder="Search by Author"
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchAuthor}
                                                    onChange={this.handleResourceAuthorChange} // Handle input changes
                                                    onKeyPress={this.handleResourceAuthorKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based on accession number */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Accession Number</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceAccessionNumberFilterID"
                                                    placeholder="Accession Number"
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.resourceSearchAccessionNumber} // Bind value to state
                                                    onChange={this.handleResourceAccessionNoChange} // Handle input changes
                                                    onKeyPress={this.handleResourceAccessionNoKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '15px', gap: '10px' }}>
                                        {/*Advance Filter Icon*/}
                                        <div id='advanceFilter' className="p-2" style={{ alignItems: "center", display: "flex" }}>
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => this.advanceFilterModal()}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get esource list filter result.</p>
                            </div>
                        </div>

                        {
                            (this.state.resourceSearchTitle !== '' || this.state.resourceSearchAuthor !== '' || this.state.resourceSearchAccessionSeries.length !== 0 || this.state.resourceSearchAccessionNumber !== ""
                                || this.state.pageIndex !== 1 || this.state.limit !== 10 || this.state.departmentAdvanceFilterValue.length !== 0
                                || this.state.locationAdvanceFilterValue.length !== 0 || this.state.typeAdvanceFilterValue.length !== 0 || this.state.filterInstituteIID !== (config.institute_id)
                            ) &&
                            <div className='filter-apply'>
                                <p className='vm_custom_body5'>Filters are applied.</p>
                                <p className="clear-all vm_custom_body5" onClick={this.handleClearAllResourceFilter}>Clear All</p>
                            </div>
                        }
                    </div>

                    {/* list table */}
                    <div className="col-md-12 px-0 div_table mt-4">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <table className="table table-bordered  vm_libraryReport_table" id="donorListReport">
                                    <thead>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="7"></th>
                                            </tr>
                                            <th>Sr.No.</th>
                                            <th>Institute Name</th>
                                            <th>Accession Series</th>
                                            <th>Accession Number</th>
                                            <th>Title</th>
                                            <th>Author</th>
                                            <th>Resource Volume</th>
                                            <th>Resource Edition</th>
                                            <th>Resource Category</th>
                                            <th>Year of Publication</th>
                                            <th>Department</th>
                                            <th>Location</th>
                                            <th>ISBN Number</th>
                                            <th>Resource Copies</th>
                                            <th>Available Copies</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.resourceListLoading ?
                                                <tr>
                                                    <td colSpan="7">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                this.state.sortedIdArray?.length > 0 ? (
                                                    this.state.sortedIdArray.map((periodicalUID, index) => {
                                                        const eResourceItem = this.state.resourceDetailsList[periodicalUID];
                                                        if (!eResourceItem) return null; // Skip if missing



                                                        return (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                <td>{eResourceItem?.resourceInstituteName || ""}</td>
                                                                <td>{eResourceItem?.AccessionText || ""}</td>
                                                                <td>{eResourceItem?.accessionnumber || ""}</td>
                                                                <td>{eResourceItem?.title || ""}</td>
                                                                <td>{eResourceItem?.author || ""}</td>
                                                                <td>{eResourceItem?.volume || ""}</td>
                                                                <td>{eResourceItem?.edition || ""}</td>
                                                                <td>{eResourceItem?.resourceCategoryName || ""}</td>
                                                                <td>{eResourceItem?.yearOfPublication || ""}</td>
                                                                <td>{eResourceItem?.stream_name || ""}</td>
                                                                <td>{eResourceItem?.locationName || ""}</td>
                                                                <td>{eResourceItem?.isbn_number || ""}</td>
                                                                <td>{eResourceItem?.copiesdetails || ""}</td>
                                                                <td>{eResourceItem?.availableResourceCount || 0}</td>
                                                            </tr>
                                                        )
                                                    })) :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.resourceDetailsList).length > 0 || Object.keys(this.state.resourceDetailsList).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalResourcesItems}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.updatePaginationCount}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalResourcesItems || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                    {
                        this.returnAdvanceFilterModelData()
                    }
                </div>
            </>
        )
    }

}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentResource);